import { useEffect } from 'react';

import { EnvUtil } from '../../utils/env-util';

export const RedirectToWorkdayTimesheets = (): null => {
  useEffect(() => {
    window.location.assign(
      `${EnvUtil.apiPortalUrl}/saml/workday?RelayState=timesheet`
    );
  }, []);
  return null;
};
